import React from "react";

export const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <svg
      cursor="pointer"
      onClick={onClick}
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="23" rx="11.5" fill="#393939" />
      <rect
        x="6.69678"
        y="7.61092"
        width="2"
        height="13"
        transform="rotate(-45 6.69678 7.61092)"
        fill="white"
      />
      <rect
        x="15.8892"
        y="6.1967"
        width="2"
        height="13"
        transform="rotate(45 15.8892 6.1967)"
        fill="white"
      />
    </svg>
  );
};
